import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { SnackbarService } from './../../../services/snackbar/snackbar.service';
import { Component, OnInit, signal, WritableSignal } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { EmpresasService } from '../../../services/empresa/empresas.service';
import { SelecionarEmpresaModal } from '../../../modals/selecionar-empresa-modal/selecionar-empresa-modal';
import { SelecionarEnderecoModal } from '../../../modals/selecionar-endereco-modal/selecionar-endereco-modal';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { CriarPessoaDTO } from '../../../dto/pessoa/CriarPessoaDTO';
import { PessoasService } from '../../../services/pessoa/pessoas.service';
import { DesvincularEmpresa } from '../cadastrar-pessoa/dialogs/desvincular-empresa/desvincular-empresa';
import { DesvincularEndereco } from '../cadastrar-pessoa/dialogs/desvincular-endereco/desvincular-endereco';
import estados from '../../../../assets/json/estados.json';
import municipios from '../../../../assets/json/municipios.json';
import { LinhaDeCuidadoDTO, Pessoa } from '../../../models/Pessoa';
import { AuthService } from '../../../services/auth/auth.service';
import { pushPaginaAtiva, clearPaginas } from '../../../shared/activePage';
import {
  Country,
  CountryPicker,
  paises,
} from '../../../components/country-picker/country-picker';
import { provideProtractorTestingSupport } from '@angular/platform-browser';

@Component({
  selector: 'app-cadastro-pessoa',
  imports: [
    FormsModule,
    CommonModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatGridListModule,
    MatSelectModule,
    MatRadioModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    MatIconModule,
    MatTableModule,
    NgxMaskDirective,
    CountryPicker,
  ],
  templateUrl: './cadastro-pessoa.html',
  styleUrl: './cadastro-pessoa.scss',
  providers: [provideNgxMask()],
})
export class CadastroPessoa implements OnInit {
  nacionalidade = '';
  tipoDocumento = '';
  numeroDocumento = '';
  nomeCompleto = '';
  dataNascimento = '';
  telefoneCelular = '';
  sexo = '';
  etnicoRacional = '';
  estadoCivil = '';
  escolaridade = '';
  ufResidencia: number | '' = '';
  cidadeResidencia: number | '' = '';
  cargo = '';
  area = '';
  situacao = '';
  turnos = new FormControl<string[]>([]);
  linhasDeCuidado: LinhaDeCuidadoDTO[] = [];

  empresaSelecionada: any = null;
  enderecoSelecionado: any = null;
  empresasOptions: any[] = [];

  touchedEmpresa = false;
  empresaDummyModel = '';

  touchedEndereco = false;
  enderecoDummyModel = '';
  telaExibida: number = 1;

  nacionalidadeOptions = ['Brasileiro', 'Estrangeiro'];
  tipoDocumentosOptions: string[] = ['CPF', 'Passaporte', 'CRNM', 'CIE'];
  sexoOptions = ['Feminino', 'Masculino', 'Prefiro não informar'];
  etnicoRacionalOptions = [
    'Branco',
    'Preto',
    'Pardo',
    'Amarelo',
    'Indígena',
    'Prefiro não informar',
  ];
  estadoCivilOptions = [
    'Solteiro',
    'Casado',
    'Separado',
    'Divorciado',
    'Viúvo',
    'Prefiro não informar',
  ];
  escolaridadeOptions = [
    'Sem instrução',
    'Fundamental incompleto',
    'Fundamental completo',
    'Médio incompleto',
    'Médio completo',
    'Superior incompleto',
    'Superior completo',
    'Pós-graduação',
    'Mestrado',
    'Doutorado',
    'Prefiro não informar',
  ];
  turnoOptions = ['Matutino', 'Vespertino', 'Noturno', 'Horário comercial'];
  situacaoOptions = ['Trabalhando', 'Afastado', 'Demitido'];
  ufOptions: { id_uf: number; sigla: string; nome: string }[] = [];
  cidadeOptions: { id_cidade: number; id_uf: number; nome: string }[] = [];
  modoEdicao = false;
  pessoaId!: number;
  observacao: string = '';

  isBrasileiro = signal(false);
  country: WritableSignal<Country | null> = signal(null);
  mascaraTelefone = signal('');

  formBloqueado = signal(false);

  constructor(
    private dialog: MatDialog,
    private readonly empresaService: EmpresasService,
    private readonly pessoaService: PessoasService,
    private readonly snackbarService: SnackbarService,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly authService: AuthService,
  ) {}

  async ngOnInit() {
    clearPaginas();
    pushPaginaAtiva({
      nome: 'Home',
      rota: '/home',
    });
    pushPaginaAtiva({
      nome: 'Pessoas',
      rota: '/pessoas',
    });
    pushPaginaAtiva({
      nome: 'Cadastro de pessoas',
      rota: '',
    });

    try {
      this.empresasOptions =
        await this.empresaService.consultaTelaVincularEmpresaAPessoa();
    } catch (err: any) {
      this.snackbarService.error('Erro ao buscar as empresas');
    }

    await this.verificarModo();

    if (this.modoEdicao) {
      this.formBloqueado.set(false);
    }

    estados.map((e) => {
      this.ufOptions.push({
        id_uf: e.codigo_uf,
        sigla: e.uf,
        nome: e.nome,
      });
    });
  }

  async verificarModo() {
    const id = this.route.snapshot.paramMap.get('id');

    if (id) {
      this.modoEdicao = true;
      this.pessoaId = +id;
      const pessoa: Pessoa = await this.pessoaService.buscarPorId(
        this.pessoaId,
      );

      this.empresaSelecionada = this.empresasOptions.find(
        (e) => e.idEmpresa == pessoa.idEmpresa,
      );
      this.enderecoSelecionado = this.empresaSelecionada.enderecos.find(
        (e: any) =>
          e.idEstabelecimento == pessoa.estabelecimentos[0].idEstabelecimento,
      );

      this.nacionalidade = pessoa.naturalidade;
      this.tipoDocumento = pessoa.tipoDocumentoAbreviacao;
      this.numeroDocumento = pessoa.numeroDocumento;
      this.nomeCompleto = pessoa.nomeCompleto;
      this.dataNascimento = pessoa.dataNascimento;
      this.sexo = pessoa.sexo;
      this.etnicoRacional = pessoa.classificacaoEtnicoRacial;
      this.estadoCivil = pessoa.estadoCivil;
      this.escolaridade = pessoa.grauEscolaridade;
      this.cargo = pessoa.cargo;
      this.area = pessoa.area;
      this.situacao = pessoa.situacao;
      this.observacao = pessoa.observacao;

      this.onCountrySelected(
        paises.find((p: Country) => p.name === pessoa.pais) || paises[0],
      );

      const ddiPais = paises.find((p: Country) => p.name === pessoa.pais)?.ddi;
      this.telefoneCelular = pessoa.telefoneCelular
        .replaceAll(`+${ddiPais}`, '')
        .replaceAll(' ', '');

      const municipioPessoa = municipios.find(
        (m: any) => m.nome === pessoa.cidadeResidencia,
      );
      if (municipioPessoa) {
        this.ufResidencia = municipioPessoa.codigo_uf;
        this.onChangeUF(this.ufResidencia);
        this.cidadeResidencia = municipioPessoa.codigo_ibge;
      }

      this.turnos.setValue(
        pessoa.turno ? pessoa.turno.split(',').map((t) => t.trim()) : [],
      );

      this.linhasDeCuidado = pessoa.linhasDeCuidado;

      if (this.formBloqueado()) {
        this.turnos.disable();
      }
    }
  }

  onCountrySelected(country: Country) {
    this.country.set(country);
    this.mascaraTelefone.set(country.mask);
  }

  getMascaraTipoDocumento(tipoSelecionado?: string) {
    switch (tipoSelecionado ?? this.tipoDocumento) {
      case 'CPF':
        return '000.000.000-00';
      default:
        return null;
    }
  }

  abrirDesvincularEmpresa() {
    const dialogRef = this.dialog.open(DesvincularEmpresa, {
      width: '400px',
      data: {
        empresa: this.empresaSelecionada,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.removeEmpresaSelecionada();
        this.snackbarService.success('Empresa desvinculada com sucesso!');
      }
    });
  }

  abrirDesvincularEndereco() {
    const dialogRef = this.dialog.open(DesvincularEndereco, {
      width: '500px',
      data: {
        empresaSelecionada: this.empresaSelecionada,
      },
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result === true) {
        this.removeEnderecoSelecionado();
        this.snackbarService.success('Endereço desvinculado com sucesso');
      }
    });
  }

  abrirModalEmpresas() {
    this.touchedEmpresa = true;
    const dialogRef = this.dialog.open(SelecionarEmpresaModal, {
      data: {
        empresas: this.empresasOptions,
        empresaSelecionada: this.empresaSelecionada,
      },
    });
    dialogRef.afterClosed().subscribe((empresa: any) => {
      if (empresa) this.empresaSelecionada = empresa;
    });
  }

  removeEmpresaSelecionada() {
    this.empresaSelecionada = null;
    this.enderecoSelecionado = null;
  }

  abrirModalEnderecos() {
    this.touchedEndereco = true;
    const dialogRef = this.dialog.open(SelecionarEnderecoModal, {
      data: {
        empresas: this.empresasOptions,
        empresaSelecionada: this.empresaSelecionada,
        enderecoSelecionado: this.enderecoSelecionado,
      },
    });

    dialogRef.afterClosed().subscribe((endereco: any) => {
      if (endereco) this.enderecoSelecionado = endereco;
    });
  }

  removeEnderecoSelecionado() {
    this.enderecoSelecionado = null;
  }

  onTouchedAll() {
    this.touchedEmpresa = true;
    this.touchedEndereco = true;
  }

  isFormularioValido(): boolean {
    const camposObrigatorios = [
      this.empresaSelecionada,
      this.enderecoSelecionado,
      this.nacionalidade,
      this.tipoDocumento,
      this.numeroDocumento?.trim(),
      this.nomeCompleto?.trim(),
      this.dataNascimento,
      this.telefoneCelular?.trim(),
      this.sexo,
      this.country(),
    ];
    return camposObrigatorios.every(
      (campo) => campo !== null && campo !== undefined && campo !== '',
    );
  }

  turnoShouldBeChecked(opt: string): boolean {
    return this.turnos?.value?.includes(opt) ?? false;
  }

  onChangeUF(idUF: number) {
    this.ufResidencia = idUF;

    this.cidadeOptions = municipios
      .filter((m) => m.codigo_uf === idUF)
      .map((m) => ({
        id_cidade: m.codigo_ibge,
        id_uf: m.codigo_uf,
        nome: m.nome,
      }));

    this.cidadeResidencia = '';
  }

  cancelar() {
    this.router.navigate(['/pessoas']);
  }

  onChangeNacionalidade(nac: string) {
    this.nacionalidade = nac;
    if (nac === 'Brasileiro') {
      this.isBrasileiro.set(true);
      this.tipoDocumento = 'CPF';
    } else {
      this.isBrasileiro.set(false);
    }
  }

  async salvaPessoa() {
    const ufObj = estados.find((uf) => uf.codigo_uf === this.ufResidencia);
    const cidadeObj = municipios.find(
      (cid) => cid.codigo_ibge === this.cidadeResidencia,
    );

    if (!this.isFormularioValido()) {
      this.snackbarService
        .setDuration(3000)
        .error('Preencha todos os campos obrigatórios antes de salvar');
      return;
    }

    const base: CriarPessoaDTO = {
      idTipoDocumento:
        this.tipoDocumentosOptions.indexOf(this.tipoDocumento) + 1,
      numeroDocumento: this.numeroDocumento,
      nomeCompleto: this.nomeCompleto,
      dataNascimento: this.dataNascimento,
      sexo: this.sexo,
      classificacaoEtnicoRacial: this.etnicoRacional,
      estadoCivil: this.estadoCivil,
      grauEscolaridade: this.escolaridade,
      naturalidade: this.nacionalidade,
      ufResidencia: ufObj?.nome || '',
      cidadeResidencia: cidadeObj?.nome || '',
      cargo: this.cargo,
      area: this.area,
      turno: Array.isArray(this.turnos.value)
        ? this.turnos.value.join(', ')
        : this.turnos.value,
      situacao: this.situacao,
      observacao: this.observacao,
      telefoneCelular: `+${this.country()?.ddi} ${this.telefoneCelular}`,
      idEstabelecimento: this.enderecoSelecionado?.idEstabelecimento,
      pais: this.country()?.name || '',
      ddi: this.country()?.ddi || '',
    };

    if (this.modoEdicao) {
      base.id = this.pessoaId;
      const res = await this.pessoaService.editarPessoa(base);
      if (res) {
        this.snackbarService.success('Pessoa editada com sucesso!');
        this.router.navigate(['/pessoas']);
      }
    } else {
      const res = await this.pessoaService.salvarPessoa(base);
      if (res) {
        this.snackbarService.success('Pessoa salva com sucesso');
        this.router.navigate(['/pessoas']);
      }
    }
  }
}
